/**
 * G7. Разговор: ребёнок приходит с проблемой, три ответа, один тап.
 * При отношениях ≥ 50 ответ «он услышит» подсвечен пометкой.
 */
import { t } from '@life/i18n';
import { TALK_RELATIONS, talkProblemKey, type TalkInput, type TalkState } from '@life/minigames';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Talk({ state, onInput }: MinigameScreenProps<TalkInput, TalkState>) {
  return (
    <>
      <p class="q-text">{t(talkProblemKey(state.problem))}</p>
      <p class="hint">{t('ui.minigame.talk.rules', { r: TALK_RELATIONS })}</p>
      <Choice
        label={t(talkProblemKey(state.problem))}
        items={state.answers.map((key, i) => ({ text: t(key), ...(state.hint === i ? { note: t('ui.minigame.talk.hint') } : {}) }))}
        value={null}
        onChange={(pick) => onInput({ pick })}
      />
    </>
  );
}
